var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "go to arrow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 7",
    cx: 20.6984,
    cy: 20,
    rx: 20.1676,
    ry: 20,
    fill: "#00ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6183 11.2985C28.2188 11.2985 28.7055 11.7812 28.7055 12.3767L28.7055 22.0805C28.7055 22.6759 28.2188 23.1587 27.6183 23.1587C27.0179 23.1587 26.5311 22.6759 26.5311 22.0805L26.5311 14.9797L13.7801 27.6247C13.3555 28.0458 12.6671 28.0458 12.2425 27.6247C11.8179 27.2036 11.8179 26.521 12.2425 26.0999L24.9935 13.4549L17.8332 13.4549C17.2328 13.4549 16.746 12.9722 16.746 12.3767C16.746 11.7812 17.2328 11.2985 17.8332 11.2985L27.6183 11.2985Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToArrow);
export default __webpack_public_path__ + "static/media/go-to-arrow.cbb809b5083b23d04432684022d1d187.svg";
export { ForwardRef as ReactComponent };